import { Component, OnInit, OnDestroy } from "@angular/core";
import { CommonModule } from "@angular/common";
import { RouterLink } from "@angular/router";
import { ToastService, Toast } from "../../services/toast.service";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";

@Component({
  selector: "app-toast-container",
  standalone: true,
  imports: [CommonModule, RouterLink],
  templateUrl: "./toast-container.component.html",
})
export class ToastContainerComponent implements OnInit, OnDestroy {
  toasts: Toast[] = [];
  private destroy$ = new Subject<void>();

  constructor(private toastService: ToastService) {}

  ngOnInit(): void {
    this.toastService.toasts$
      .pipe(takeUntil(this.destroy$))
      .subscribe(toasts => {
        this.toasts = toasts;
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  /**
   * Remove a toast
   */
  removeToast(id: string): void {
    this.toastService.removeToast(id);
  }

  /**
   * Get the appropriate icon for each toast type
   */
  getToastIcon(type: Toast['type']): string {
    switch (type) {
      case 'success':
        return 'M5 13l4 4L19 7'; // Check mark
      case 'error':
        return 'M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z'; // Exclamation
      case 'warning':
        return 'M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.864-.833-2.634 0L4.168 16.5c-.77.833.192 2.5 1.732 2.5z'; // Triangle warning
      case 'info':
        return 'M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z'; // Info circle
      default:
        return '';
    }
  }

  /**
   * Get the appropriate icon color classes for each toast type
   * Using consistent coloring for all toast types with black background
   */
  getIconClasses(type: Toast['type']): string {
    switch (type) {
      case 'success':
        return 'text-green-400 dark:text-green-600';
      case 'error':
        return 'text-red-400 dark:text-red-600';
      case 'warning':
        return 'text-yellow-400 dark:text-yellow-600';
      case 'info':
        return 'text-blue-400 dark:text-blue-600';
      default:
        return 'text-gray-400 dark:text-gray-600';
    }
  }

  /**
   * Track by function for ngFor to optimize rendering
   */
  trackByToastId(index: number, toast: Toast): string {
    return toast.id;
  }

  /**
   * Handle action button click
   */
  handleAction(toast: Toast): void {
    if (toast.action?.callback) {
      toast.action.callback();
    }
    this.removeToast(toast.id);
  }
}